const ATS_VERSION = "1.6.0";
// eslint-disable-next-line import/prefer-default-export
export { ATS_VERSION };
//# sourceMappingURL=version.js.map